import styled from "styled-components";

const StyledMainContent = styled.main`
position: relative;
min-height: 100vh;
margin-left: 16.5rem ;

@media screen and (max-width: 1120px) {
    margin-left: 0px;
  }


`;
export default StyledMainContent;